import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class GlobalSearchService extends BaseService {
	constructor() {
		super('/GlobalSearch');
	}

	public getSearchWorld(idTenant: number, searchWord: string, ignoreDiacritics: boolean, countResult: number) {
		return super.getByIdWithResourceName(idTenant, this._resourceName + '/search/' + searchWord + '/' + ignoreDiacritics + '/' + countResult);
	}

	public getAllByFilter(filter: GlobalSearchFilter) {
		return super.getAllByFilterBase(filter);
	}

}

	export class GlobalSearchFilter extends BaseFilter {
		constructor(idTenant?: number | null, searchWord?: string | null,
			ignoreDiacritics?: boolean | null, perPage?: number | null, currentPage?: number | null, sortBy?: string | null, sortDesc?: boolean | null, filters?: string | null) {
		super();
	
			this._idTenant = idTenant;
			this._searchWord = searchWord;
			this._ignoreDiacritics = ignoreDiacritics;

			this._perPage = perPage;
			this._currentPage = currentPage;
			this._sortBy = sortBy;
			this._sortDesc = sortDesc;
			this._filters = filters;
	}
	
	private _idTenant?: number | null;
		private _searchWord?: string | null;
		private _ignoreDiacritics?: boolean | null;
		//TODO tohle prevest do nejake obecneho
		private _perPage?: number | null;
		private _currentPage?: number | null;
		private _sortBy?: string | null;
		private _sortDesc?: boolean | null;
		private _filters?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._searchWord != null ? { SearchWord: this._searchWord } : {}),
			(this._ignoreDiacritics != null ? { IgnoreDiacritics: this._ignoreDiacritics } : {}),

			(this._perPage != null ? { PerPage: this._perPage } : {}),
			(this._currentPage != null ? { CurrentPage: this._currentPage } : {}),
			(this._sortBy != null ? { SortBy: this._sortBy } : {}),
			(this._sortDesc != null ? { SortDesc: this._sortDesc } : {}),
			(this._filters != null ? { Filters: this._filters } : {})

		);

		return data;
	};
}

